import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header-section" }

import {getSliceComponentProps} from '@prismicio/vue';
    import {linkResolver, ServerSideNavigationPrismicLink} from '@malt/vue-prismic';
    import {HeaderLinksSliceSlice} from '@/unlogged/prismicio';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: getSliceComponentProps<HeaderLinksSliceSlice>(),
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slice.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `slice-item-${i}`,
        class: "header-link"
      }, [
        _createVNode(_unref(ServerSideNavigationPrismicLink), {
          field: item.link,
          "data-heap": item.heapId,
          "link-resolver": _unref(linkResolver)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.linkText), 1)
          ]),
          _: 2
        }, 1032, ["field", "data-heap", "link-resolver"])
      ]))
    }), 128))
  ]))
}
}

})